// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".asset-table-display__asset-icon[data-v-ac81a0c4]{height:28px;width:28px}@media only screen and (max-width:959px){.asset-table-display__divider[data-v-ac81a0c4]{border-bottom:2px solid var(--v-softened-base)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
